export default __webpack_public_path__ + "static/media/avatar.ca4e0278.png";